import type { FormDefinition } from '@/core/templates/types'

export default {
  sections: {
    Maßnahme: {
      fields: [
        { id: 'Maßnahme.Bezeichnung der Maßnahme', control: 'select', options: [] },
        { id: 'Maßnahme.Coach auswählen', control: 'select', options: [] },
        { id: 'Maßnahme.Zweiter Coach (optional)', control: 'select', options: [] },
        { id: 'Maßnahme.Beginn der Teilnahme', control: 'date' },
        { id: 'Maßnahme.Ende der Teilnahme', control: 'date' },
      ],
    },
  },
} satisfies FormDefinition
